<div class="cliente-form-info" *ngIf="entity && entity.pessoa">
    <div class="row">
        <div class="form-group col-12">
            <h5 class="cliente-nome">{{entity.pessoa.nome}}</h5>
            <p class="cliente-nome-fantasia">{{entity.pessoa.nomeFantasia}}</p>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label">Origem</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="{{entity.origem | origemIcon}}"></i>
                    </span>
                </div>
                <input type="text" disabled readonly class="form-control" value="{{entity.origem | origem}}">
            </div>
        </div>
    </div>

    <div class="row" *ngIf="config?.isOrigemCampanha">
        <div class="form-group col-12">
            <label class="col-form-label">Campanha de Origem</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.campanhaOrigem?.nome">
        </div>
    </div>
    <div class="row" *ngIf="entity.idCampanhaAquisicao">
        <div class="form-group col-12">
            <label class="col-form-label">Campanha de Aquisição</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.campanhaAquisicao?.nome">
        </div>
    </div>

    <div class="row" *ngIf="config?.isOrigemMidiaSocial">
        <div class="form-group col-12">
            <label class="col-form-label">Canal da Mídia Social</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="{{entity.canalMidiaSocial | canalMidiaSocialIcon}}"></i>
                    </span>
                </div>
                <input type="text" disabled readonly class="form-control" value="{{entity.canalMidiaSocial | canalMidiaSocial}}">
            </div>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-user"></i> Contato</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.contatoPrincipal?.nome">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12 col-md">
            <label class="col-form-label"><i class="fas fa-phone-alt"></i> Telefone</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.contatoPrincipal?.fone">
        </div>
        <div class="form-group col-12 col-md">
            <label class="col-form-label"><i class="fas fa-mobile-alt"></i> Celular</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.contatoPrincipal?.celular">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="far fa-envelope"></i> E-mail</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.contatoPrincipal?.email">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-map-marker-alt"></i> Cidade</label>
            <input type="text" disabled readonly class="form-control" value="{{entity.pessoa.enderecoPrincipal?.cidade?.nome}} - {{entity.pessoa.enderecoPrincipal?.cidade?.estado?.uf}}">
        </div>
    </div>

    <div class="row" *ngIf="entity.idLead">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-pen-alt"></i> Anotação do Lead</label>
            <textarea class="form-control" disabled readonly sgtAutosize>{{entity.lead?.anotacao}}</textarea>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-pen-alt"></i> Anotação</label>
            <textarea class="form-control" disabled readonly sgtAutosize>{{entity.anotacao}}</textarea>
        </div>
    </div>

    <!-- Outros Contatos -->
    <sgt-collapse-group title="Outros Contatos" [isCollapsedInDefault]="false" *ngIf="entity.pessoa.outrosContatos && entity.pessoa.outrosContatos.length > 0">
        <sgt-pessoa-contato-list-group
            [contatos]="entity.pessoa.outrosContatos"
            [canOpen]="false">
        </sgt-pessoa-contato-list-group>
    </sgt-collapse-group>

    <!-- Identificação -->
    <sgt-collapse-group title="Identificação" [isCollapsedInDefault]="false">
        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Tipo</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.tipo | pessoaTipo">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">{{entity.pessoa.tipo | pessoaTipoAbreviacao}}</label>
                <div class="input-group">
                    <div class="input-group-prepend" *ngIf="entity.pessoa.identificadorMatrizFilial">
                        <sgt-identificador-matriz-filial-input-group-text
                            [identificador]="entity.pessoa.identificadorMatrizFilial"
                            [prepend]="true">
                        </sgt-identificador-matriz-filial-input-group-text>
                    </div>
                    <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.cnpjCpf">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="dataFundacao" class="col-form-label">
                    <span *ngIf="config?.isTipoPessoaFisica">Data de Nascimento</span>
                    <span *ngIf="!config?.isTipoPessoaFisica">Data de Abertura</span>
                </label>
                <input type="text" disabled readonly class="form-control" value="{{entity.pessoa.dataFundacao | date: 'dd/MM/yyyy'}}">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-porte-empresa-form-control
                    [codigo]="entity.pessoa.porteEmpresaCodigo"
                    [nome]="entity.pessoa.porteEmpresaNome">
                </sgt-porte-empresa-form-control>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-natureza-juridica-form-control
                    [codigo]="entity.pessoa.naturezaJuridicaCodigo"
                    [nome]="entity.pessoa.naturezaJuridicaNome">
                </sgt-natureza-juridica-form-control>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Periodicidade de Compra</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.periodicidadeCompra?.nome">
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Periodicidade de Compra Semana</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.periodicidadeCompraSemana | periodicidadeCompraSemana">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Segmentos</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.classificacoesNome">
            </div>
        </div>
    </sgt-collapse-group>

    <!-- Endereço -->
    <sgt-collapse-group title="Endereço" [isCollapsedInDefault]="false">
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">CEP</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.enderecoPrincipal?.cep">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Logradouro</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.enderecoPrincipal?.logradouro">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label class="col-form-label">Número</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.enderecoPrincipal?.numero">
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Bairro</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.enderecoPrincipal?.bairro">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Complemento</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.pessoa.enderecoPrincipal?.complemento">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Cidade</label>
                <input type="text" disabled readonly class="form-control" value="{{entity.pessoa.enderecoPrincipal?.cidade?.nome}} - {{entity.pessoa.enderecoPrincipal?.cidade?.estado?.uf}}">
            </div>
        </div>
    </sgt-collapse-group>

    <!-- Simples Nacional -->
    <sgt-collapse-group title="Simples Nacional" [isCollapsedInDefault]="false" *ngIf="config?.isTipoPessoaJuridica">
        <div class="row">
            <div class="form-group col-12">
                <sgt-simples-nacional-form
                    #simplesNacionalForm
                    [entity]="entity"
                    [canEdit]="false"
                    [isMini]="true">
                </sgt-simples-nacional-form>
            </div>
        </div>
        <div class="row" *ngIf="config?.isTipoPessoaJuridica && entity.optanteSimplesNacional">
            <div class="form-group col-12">
                <sgt-mei-form
                    #meiForm
                    [entity]="entity"
                    [canEdit]="false"
                    [isMini]="true">
                </sgt-mei-form>
            </div>
        </div>
    </sgt-collapse-group>

    <!-- CNAEs e QSA -->
    <sgt-collapse-group title="CNAEs e QSA" [isCollapsedInDefault]="false">
        <div class="row">
            <div class="form-group col-12">
                <sgt-cnaes-view
                    [cnaePrincipal]="entity.pessoa.cnaePrincipal"
                    [cnaesSecundarias]="entity.pessoa.cnaesSecundarias | cnaeSecundariasViewerMap">
                </sgt-cnaes-view>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-capital-social-form-control-text
                    [capitalSocial]="entity.pessoa.capitalSocial">
                </sgt-capital-social-form-control-text>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-socio-view
                    [socios]="entity.pessoa.socios">
            </sgt-socio-view>
            </div>
        </div>
    </sgt-collapse-group>
</div>
